import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { QuestionService } from '../../services/question.service';
import {ApiService} from '../../services/api.service';

@Component({
    selector: 'analyse',
    templateUrl: './analyse.component.html'
})
export class AnalyseComponent implements OnInit {
    public section: number | string = 0;
    public activeSection: Object = {};
    public sections: Object[] = [];
    public questions: Object[] = [];
    public answers: Object = {};
    public answerCount: number = 0;
    public showResetModal = false;
    public showAfterDiv: boolean = false;
    public showBeforeDiv: boolean = true;
    public breadcrumbs = [{
        url: '/',
        label: 'Home'
    }, {
        label: 'Huidanalyse'
    }];
    public isLoading: boolean = false;

    constructor(private titleService: Title, private questionService: QuestionService, private route: ActivatedRoute, private router: Router) { }

    ngOnInit() {
        this.titleService.setTitle('Dermabase - Huidanalyse');

        if (ApiService.readObjectToken('currentAnswers')) {
            this.answers = ApiService.readObjectToken('currentAnswers');
        }

        this.route.params.subscribe(params => {
            this.section = params['section'];

            if (this.section == 'reset') {
                ApiService.eraseToken('collection');
                ApiService.eraseToken('excl');
                ApiService.eraseToken('activePackaging');
                ApiService.eraseToken('activePrice');
                ApiService.eraseToken('activeQty');
                ApiService.eraseToken('activeFilters');
                this.navigate(['huidanalyse','0'],true);
                return '';
            }
            this.section = +this.section;

            const len = Object.keys(this.answers).length;
            if(this.section > len) {
                this.navigate(['huidanalyse', '' + len], true);
            }

            this.get();
        });
    }

    ngOnChanges() {
        this.get();
    }

    private get() {
        this.isLoading = true;
        this.questionService.getSections().subscribe((res) => {
            this.sections = res.data.filter((e) => { return e['filter'] != 1 });

            if (this.section === 0 && Object.keys(this.answers).length === this.sections.length) {
                this.toggleResetAnswerModal();
            }

            if ((this.section === this.sections.length) && (Object.keys(this.answers).length === this.sections.length)) {
                let answers = [];
                Object.keys(this.answers).forEach((o) => {
                    Object.keys(this.answers[o]).filter((e)=> {
                        return this.answers[o][e]['filter'] != 1
                    }).forEach((co) => {
                        answers = [...answers,...this.answers[o][co]['id']];
                    });
                });
                ApiService.writeToken(answers.join(','),'collection');

                let excl = [];
                Object.keys(this.answers).forEach((o) => {
                    Object.keys(this.answers[o]).filter((e)=> {
                        return this.answers[o][e]['filter'] == 1
                    }).forEach((co) => {
                        excl = [...excl,...this.answers[o][co]['ingredients']];
                    });
                });
                ApiService.writeToken(excl.filter(function (item, pos) {return excl.indexOf(item) == pos}).sort().join(','),'excl');

                this.questionService.storeAnalysis(this.answers).subscribe((res) => {
                    console.log('storeAnalysis: ' + res);
                },(error) => {
                    alert(error);
                });

                this.navigate(['huidanalyse', 'resultaat'], true);
                return '';
            }

            this.activeSection = this.sections[this.section];

            this.questionService.getQuestions(this.activeSection['id']).subscribe((res) => {
                this.questions = res.data;
                this.answerCount = this.questions.length;
                this.isLoading = false;
            });
        });
    }

    public navigate(commands: string[], force: boolean = false) {
        if (force || (this.answers[this.section] && Object.keys(this.answers[this.section]).length >= this.answerCount)) {
            this.router.navigate(commands);
        }
        else {
            alert('Beantwoord alle vragen');
        }
    }

    public goToSection(index) {
        if (index <= Object.keys(this.answers).length) {
            this.navigate(['huidanalyse', index]);
        }
    }

    public toggleAnswer(question, answer) {
        if (!this.answers[this.section]) {
            this.answers[this.section] = {};
        }
        this.answers[this.section][question['id']] = {
            id: answer['id'],
            filter: question['Filter'],
            label: answer['Antwoord'],
            ingredients: answer['ingredients']
        };

        ApiService.writeObjectToken(this.answers, 'currentAnswers');
        if(answer['id'] == "recjmuWT5HNf8LNZF") {
            this.answers[this.section]['reclp0WNZspNohKi3'] = {
                id: "recKZ9GEdXyv6Kufn",
                filter: "",
                label: "Nee",
                ingredients: answer['ingredients']
            };
            ApiService.writeObjectToken(this.answers, 'currentAnswers');
        }
        if(answer['id'] == "recoCNuQY33XpAUXp") {
            this.answers[this.section]['recsoY2pSfVLCrTl3'] = {
                id: "recag5iIQbn7VtGkK",
                filter: "",
                label: "Nee",
                ingredients: answer['ingredients']
            };
            ApiService.writeObjectToken(this.answers, 'currentAnswers');
        }
        
    }

    public getAnswers(index) {
        if (this.answers[index]) {
            return Object.keys(this.answers[index]);
        }

        return [];
    }

    public isShortAnswers(answers: Object[]) {
        return answers.map((o)=>{return o['Antwoord']}).join('').length <= 20;
    }

    public toggleResetAnswerModal() {
        this.showResetModal = !this.showResetModal;
        const body = document.body;
        if (this.showResetModal) {
            body.classList.add('modal-active');
        } else {
            body.classList.remove('modal-active');
        }
    }

    public resetAnswers() {
        ApiService.eraseToken('currentAnswers');
        this.answers = {};
        this.toggleResetAnswerModal();
        this.ngOnInit();
    }

    public showAfter() {
        ApiService.eraseToken('currentAnswers');
        this.answers = {};
        this.toggleResetAnswerModal();
        this.ngOnInit();
        this.showAfterDiv = true;
        this.showBeforeDiv = false;
    }
}


// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/analyse/analyse.component.ts